export default {
  homeUi: {
    seo: {
      title: 'AQUAMARINA TOURS | Passeios de Escuna, Lancha e Jeep em Paraty',
      description: 'AQUAMARINA TOURS - Experiências oceânicas únicas em Paraty, RJ. Passeios de escuna, lanchas privativas, jeep tour pela Costa Verde, snorkel e mergulho.',
    },
    hero: {
      subtitleTail: 'esperando por você nas águas cristalinas de Paraty.',
      showcaseBadge: 'DESTAQUE AQUAMARINA',
      showcaseCta: 'Ver passeio',
      showcaseAria: 'Ver detalhes de {{title}}',
      experiencesAria: 'Experiências disponíveis',
      experiences: {
        schooner: 'ESCUNA',
        boat: 'LANCHA',
        jeep: 'JEEP',
        diving: 'MERGULHO',
      },
      featuredAria: 'Passeios em destaque',
      route: 'PARATY · COSTA VERDE · BRASIL',
      scrollCue: 'ROLE PARA EXPLORAR',
    },
    why: {
      safety: 'Tripulação treinada, coletes salvavidas para todos os passageiros e embarcações inspecionadas regularmente pela Marinha do Brasil.',
      guides: 'Nossos guias conhecem cada canto de Paraty — das praias escondidas às histórias por trás de cada ilha.',
      boats: 'Escunas confortáveis, lanchas modernas e jeeps 4x4 revisados. Equipamento de snorkel e mergulho de primeira linha.',
      price: 'Sem taxas ocultas. O valor do site é o valor final. Parcelamos em até 3x no cartão.',
    },
    bolivia: {
      bgAlt: 'Salar de Uyuni Bolívia',
      slideAlt: 'Expedição Salar de Uyuni',
      included: {
        accommodation: 'Hospedagem 2 Noites',
        meals: 'Todas as Refeições',
        transport: 'Transporte 4x4',
        guide: 'Guia Experiente',
        sunset: 'Pôr do Sol no Salar',
        flamingos: 'Flamingos & Lagoas',
      },
    },
    trust: {
      cadasturAlt: 'Cadastur - Cadastro Nacional de Prestadores de Serviços Turísticos',
      tripadvisorAlt: 'Avaliação 5 estrelas no Tripadvisor',
      tripadvisorText: 'Certificado de Excelência',
      googleAlt: 'Avaliação 4.9 no Google',
      googleText: '4.9/5 Google Reviews',
      supportName: 'Atendimento',
      supportAlt: 'Atendimento via WhatsApp',
      supportText: 'Suporte 24h',
    },
    contact: {
      mapTitle: 'Mapa de Paraty',
    },
    testimonials: {
      ratingAria: '{{rating}} de 5',
    },
    footer: {
      links: 'Links',
      privacy: 'Privacidade',
      cookies: 'Cookies',
      terms: 'Termos',
      reservations: 'Reservas',
      cancellations: 'Cancelamentos',
    },
    cart: {
      floatingAria: 'Carrinho de passeios',
    },
    countdown: {
      aria: 'Contagem regressiva: {{time}}',
    },
    marquee: {
      aria: 'Nossas experiências',
    },
  },
};
